import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Banner from '../../../components/shop/Banner/Banner';
import UnifiedNavV2 from '../../../components/common/header/UnifiedNavV2';
import DomainUtils from '../../../util/DomainUtils';

const ShopHeader = ({
  aboveBannerContent,
  metaData,
  activePrimaryLink,
  activeSecondaryLink,
  isWeddingBoutiquePage,
  hasNoSearchResults,
  hasNoResultBehaviour,
}) => {
  const title = metaData && metaData.title ? metaData.title : 'The home of all things wedding';
  const defaultMetaDescription =
    'Zola, the wedding company that’ll do anything for love, is reinventing the wedding planning and registry experience with a free suite of planning tools.';
  const metaDescription =
    metaData && metaData.description ? metaData.description : defaultMetaDescription;

  // Determine canonical url
  const isExcludedFromHomeStore = metaData && metaData.isExcludedFromHomeStore;
  const baseDomain = isExcludedFromHomeStore
    ? window.location.origin
    : DomainUtils.getHomeStoreDomain();
  const canonical = `${baseDomain}${window.location.pathname}`;
  const classes = cx(hasNoResultBehaviour ? '' : 'row hidden-xs hidden-sm');

  const imageUrl = 'https://www.zola.com/assets/images/zola-logo-big.png';
  return (
    <>
      <Helmet defaultTitle={`${title} | Zola`}>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={canonical} />
        {/* Social Tags */}
        <meta name="twitter:title" property="twitter:title" content={title} />
        <meta name="twitter:image" property="twitter:image" content={imageUrl} />
        <meta name="twitter:site" property="twitter:site" content="@zola" />
        <meta name="twitter:description" property="twitter:description" content={metaDescription} />
        <meta name="og:type" property="og:type" content="website" />
        <meta name="og:title" property="og:title" content={title} />
        <meta name="og:description" property="og:description" content={metaDescription} />
        <meta name="og:image" property="og:image" content={imageUrl} />
        <meta name="og:site_name" property="og:site_name" content="Zola" />
        <meta name="og:url" property="og:url" content={window.location.href} />
      </Helmet>
      <UnifiedNavV2
        showPromo
        activePrimaryLink={activePrimaryLink}
        activeSecondaryLink={activeSecondaryLink}
        isWeddingBoutiquePage={isWeddingBoutiquePage}
      />
      {hasNoSearchResults ? aboveBannerContent : !!aboveBannerContent && aboveBannerContent}
      <div className={classes}>
        {hasNoResultBehaviour ? '' : <Banner isWeddingBoutiquePage={isWeddingBoutiquePage} />}
      </div>
    </>
  );
};

ShopHeader.propTypes = {
  aboveBannerContent: PropTypes.node,
  metaData: PropTypes.shape({}),
  hasNoSearchResults: PropTypes.bool,
};

export default ShopHeader;
